import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <div className="footer-logo">
          <img src="/images/logo-footer.png" alt="Grounded Coffee Co. Logo" />
        </div>
        <div className="footer-links">
          <ul>
            <li><Link to="/">Menu</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/location">Find Us</Link></li>
            <li><Link to="/loyalty">Loyalty Program</Link></li>
          </ul>
        </div>
        <div className="footer-social">
          <a href="https://instagram.com/groundedcoffee_co" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-instagram"></i>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61574970351549" target="_blank" rel="noopener noreferrer">
            <i className="fab fa-facebook"></i>
          </a>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2023 Grounded Coffee Co. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;

